<div *ngIf="mapLoader.mapsLoaded | async">
  <google-map [zoom]="4"
              (mapClick)="selectLocation($event.latLng)"
              [center]="value || mapLocation"
              width="100%">
    <map-marker *ngIf="value" [position]="value"></map-marker>
  </google-map>
</div>
